// @flow

import {defineMessages} from 'react-intl';

export const actionsRolesAllow = defineMessages({
  createRefundPayments: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.createRefundPayments',
    description: 'Text explaining that a user can create and refund payments.',
    defaultMessage: 'Create or refund payments',
  },
  createPayments: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.createPayments',
    description: 'Text explaining that a user can create payments.',
    defaultMessage: 'Create payments',
  },
  createViewRefundPayments: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.createViewRefundPayments',
    description:
      'Text explaining that a user can create, view, and refund payments.',
    defaultMessage: 'Create, view, refund payments',
  },
  createViewRefundPaymentsPlatform: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.createViewRefundPaymentsPlatform',
    description:
      'Text explaining that a user can create, view, and refund payments on the platform account.',
    defaultMessage: 'Create, view, refund payments (made on the platform)',
  },
  createViewRefundPaymentsBoth: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.createViewRefundPaymentsBoth',
    description:
      'Text explaining that a user can create, view, and refund payments on the platform or connected account.',
    defaultMessage:
      'Create, view, refund payments (on the platform or connected accounts)',
  },
  viewPaymentsOnConnectedAccount: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.viewPaymentsOnConnectedAccount',
    description:
      'Text explaining that a user can view payments on connected accounts.',
    defaultMessage: 'View payments made on connected accounts',
  },
  viewPayments: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.viewPayments',
    description: 'Text explaining that a user can view payments.',
    defaultMessage: 'View payments',
  },
  viewRefundPayments: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.viewRefundPayments',
    description: 'Text explaining that a user can view and refund payments.',
    defaultMessage: 'View and refund payments',
  },
  createEditDeleteProducts: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.createEditDeleteProducts',
    description:
      'Text explaining that a user can create, edit, and delete products',
    defaultMessage: 'Create, edit, delete products',
  },
  createViewEditDeleteProducts: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.createViewEditDeleteProducts',
    description:
      'Text explaining that a user can create, view, edit, and delete products',
    defaultMessage: 'Create, view, edit, delete products',
  },
  createViewEditDeleteProductsPlatform: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.createViewEditDeleteProductsPlatform',
    description:
      'Text explaining that a user can create, view, edit, and delete products on platform account.',
    defaultMessage: 'Create, view, edit, delete products (on the platform)',
  },
  createViewEditDeleteProductsBoth: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.createViewEditDeleteProductsBoth',
    description:
      'Text explaining that a user can create, view, edit, and delete products on platform or connected account.',
    defaultMessage:
      'Create, view, edit, delete products (on the platform or connected accounts)',
  },
  viewProductsOnConnectedAccount: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.viewProductsOnConnectedAccount',
    description:
      'Text explaining that a user can view products on connected account',
    defaultMessage: 'View products on connected accounts',
  },
  viewProducts: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.viewProducts',
    description: 'Text explaining that a user can view products',
    defaultMessage: 'View products',
  },
  createEditDeleteCustomers: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.createEditDeleteCustomers',
    description:
      'Text explaining that a user can create, edit, and delete customers.',
    defaultMessage: 'Create, edit, delete customers',
  },
  createViewEditDeleteCustomers: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.createViewEditDeleteCustomers',
    description:
      'Text explaining that a user can create, view, edit, and delete customers.',
    defaultMessage: 'Create, view, edit, delete customers',
  },
  viewCustomersOnConnectedAccount: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.viewCustomersOnConnectedAccount',
    description:
      'Text explaining that a user can view customers on connected account.',
    defaultMessage: 'View customers on connected accounts',
  },
  viewCustomers: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.viewCustomers',
    description: 'Text explaining that a user can view customers',
    defaultMessage: 'View customers',
  },
  createViewEditDeleteCustomersPlatform: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.createViewEditDeleteCustomersPlatform',
    description:
      'Text explaining that a user can create, view, edit, and delete customers on the platform account.',
    defaultMessage: 'Create, view, edit, delete customers (on the platform)',
  },
  createViewEditDeleteCustomersBoth: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.createViewEditDeleteCustomersBoth',
    description:
      'Text explaining that a user can create, view, edit, and delete customers on the platform or connected account.',
    defaultMessage:
      'Create, view, edit, delete customers (on the platform or connected accounts)',
  },
  createEditRejectConnectedAccounts: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.createEditRejectConnectedAccounts',
    description:
      'Text explaining that a user can create, view, and reject connected accounts.',
    defaultMessage: 'Create, edit, reject connected accounts',
  },
  createViewEditRejectConnectedAccounts: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.createViewEditRejectConnectedAccounts',
    description:
      'Text explaining that a user can create, view, and reject connected accounts.',
    defaultMessage: 'Create, view, edit, reject connected accounts',
  },
  rejectConnectedAccounts: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.rejectConnectedAccounts',
    description: 'Text explaining that a user can reject connected accounts.',
    defaultMessage: 'Reject connected accounts',
  },
  viewOrRejectConnectedAccounts: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.viewOrRejectConnectedAccounts',
    description:
      'Text explaining that a user can view or reject connected accounts.',
    defaultMessage: 'View or reject connected accounts',
  },
  viewConnectedAccounts: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.viewConnectedAccounts',
    description: 'Text explaining that a user can view connected accounts.',
    defaultMessage: 'View connected accounts',
  },
  createConnectedAccounts: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.createConnectedAccounts',
    description: 'Text explaining that a user can view connected accounts.',
    defaultMessage: 'Create connected accounts',
  },
  viewBalance: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.viewBalance',
    description: 'Text explaining that a user can view balance',
    defaultMessage: 'View balance',
  },
  transferBalanceAndReverseTransfers: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.transferBalanceAndReverseTransfers',
    description:
      'Text explaining that a user can transfer balances to connected accounts and reverse transfers.',
    defaultMessage:
      'Transfer balance to connected account or reverse transfers',
  },
  viewTransfers: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.viewTransfers',
    description: 'Text explaining that a user can view transfers',
    defaultMessage: 'View transfers',
  },
  payoutBalanceToExternalBankAccount: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.payoutBalanceToExternalBankAccount',
    description:
      'Text explaining that a user can payout balance to external bank account.',
    defaultMessage: 'Payout balance to external bank account',
  },
  addEditRemoveTeamMembers: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.addEditRemoveTeamMembers',
    description: 'Text explaining that a user can invite team members.',
    defaultMessage: 'Invite, edit, remove team members',
  },
  createEditDeleteAPIKeys: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.createEditDeleteAPIKeys',
    description:
      'Text explaining that a user can create, edit and delete api keys.',
    defaultMessage: 'Create, view, edit, delete API keys',
  },
  addAndEditBankAccountDetails: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.addAndEditBankAccountDetails',
    description:
      'Text explaining that a user can add and edit bank account details',
    defaultMessage: 'View, add, and edit bank account details',
  },
  editPayoutSchedule: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.editPayoutSchedule',
    description: 'Text explaining that a user can edit payout schedules',
    defaultMessage: 'View and edit payout schedule',
  },
  editConnectedAccountPayoutSchedule: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.editConnectedAccountPayoutSchedule',
    description:
      'Text explaining that a user can edit payout schedules for connected accounts',
    defaultMessage: 'Edit connected account payout schedules',
  },
  viewPayouts: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.viewPayouts',
    description: 'Text explaining that a user can view payouts',
    defaultMessage: 'View payouts',
  },
  editAccountDetails: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.editAccountDetails',
    description: 'Text explaining that a user can edit account details',
    defaultMessage: 'View and edit account details (address and contact)',
  },
  editAllProductSettings: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.editAllProductSettings',
    description: 'Text explaining that a user can edit all product settings.',
    defaultMessage:
      'Configure all product settings (for example, payment methods, radar settings, or connect settings)',
  },
  viewAndEditAlmostAllProductSettingsExceptTerminalAndClimate: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.viewAndEditAlmostAllProductSettingsExceptTerminalAndClimate',
    description:
      'Text explaining that a user can view and edit almost all climate settings.',
    defaultMessage:
      'View and edit almost all product settings (for example, payment methods, radar settings, or connect settings) except terminal and climate',
  },
  configureAnyProductSettings: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.configureAnyProductSettings',
    description: 'Text explaining that a user can edit any product settings.',
    defaultMessage:
      'Configure any product settings (for example, payment methods, radar settings, or connect settings)',
  },
  editAnyProductSettingsBesidesTax: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.editAnyProductSettingsBesidesTax',
    description:
      'Text explaining that a user can edit any product settings besides tax.',
    defaultMessage:
      'Edit any non-tax product settings (for example, payment methods, radar settings, or connect settings)',
  },
  connectAccountToConnectPlatforms: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.connectAccountToConnectPlatforms',
    description:
      'Text explaining that a user can connect the account to platform accounts.',
    defaultMessage: `Connect account to <a>connect</a> platforms`,
  },
  bulkExport: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.bulkExport',
    description:
      'Text explaining that a user can do bulk exports of payments, customers, products, and connected accounts.',
    defaultMessage:
      'Bulk exports of payments, customers, products, and connected accounts',
  },
  changeDefaultPayoutCurrency: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.changeDefaultPayoutCurrency',
    description:
      'Text explaining that a user can change the default payout currency',
    defaultMessage: 'Change default payout currency',
  },
  deleteTheDefaultBankAccount: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.deleteTheDefaultBankAccount',
    description:
      'Text explaining that a user can delete the default bank account.',
    defaultMessage: 'Delete the default bank account',
  },
  changeAccountOwner: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.changeAccountOwner',
    description: 'Text explaining that a user can change the account owner.',
    defaultMessage: 'Change the account owner',
  },
  createAndManageGroups: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.createAndManageGroups',
    description: 'Text explaining that a user can create or edit groups.',
    defaultMessage: 'Create and manage user groups',
  },
  viewSecurityHistory: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.viewSecurityHistory',
    description: 'Text explaining that a user view the security history.',
    defaultMessage: 'View security history',
  },
  viewDisputes: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.viewDisputes',
    description: 'Text explaining that a user view disputes',
    defaultMessage: 'View disputes',
  },
  resolveDisputes: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.resolveDisputes',
    description: 'Text explaining that a user resolve disputes.',
    defaultMessage: 'Resolve disputes',
  },
  viewAndResolveDisputes: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.viewAndResolveDisputes',
    description: 'Text explaining that a user view and resolve disputes.',
    defaultMessage: 'View and resolve disputes',
  },
  viewAndResolveDisputesConnect: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.viewAndResolveDisputesConnect',
    description: 'Text explaining that a user view and resolve disputes.',
    defaultMessage: 'View and resolve disputes on connected accounts',
  },
  viewAndResolveDisputesBoth: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.viewAndResolveDisputesBoth',
    description:
      'Text explaining that a user view and resolve disputes on platform or connected account.',
    defaultMessage:
      'View and resolve disputes (on the platform or connected accounts)',
  },
  viewAndResolveDisputesPlatform: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.viewAndResolveDisputesPlatform',
    description:
      'Text explaining that a user view and resolve disputes on platform account.',
    defaultMessage: 'View and resolve disputes (made on the platform)',
  },
  editConnectedAcctCapabilities: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.editConnectedAcctCapabilities',
    description:
      'Text explaining that a user can edit connected account capabilities',
    defaultMessage: 'Edit connected account capabilities',
  },
  viewRadar: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.viewRadar',
    description:
      'Text explaining that a user can view radar rules and settings.',
    defaultMessage: 'View radar rules and settings',
  },
  manageFinancialReports: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.manageFinancialReports',
    description:
      'Text explaining that a user can create, view, and download financial reports',
    defaultMessage: 'Create, view, download financial reports',
  },
  viewEventsAndLogs: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.viewEventsAndLogs',
    description: 'Text explaining that a user can view events and logs.',
    defaultMessage: 'View events and logs',
  },
  createViewEditConnectedAccounts: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.createViewEditConnectedAccounts',
    description:
      'Text explaining that a user can create, view, and edit connected accounts',
    defaultMessage: 'Create, view, edit connected accounts',
  },
  addPersonToConnectedAccount: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.addPersonToConnectedAccount',
    description:
      'Text explaining that a user can add a person to a connected account.',
    defaultMessage: 'Add person to a connected account',
  },
  addFunds: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.addFunds',
    description: 'Text explaining that a user can add funds to their account',
    defaultMessage: 'Add funds to a balance',
  },
  createOutboundPayments: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.createOutboundPayments',
    description: 'Text explaining that a user can initiate outbound payments.',
    defaultMessage: 'Initiate ACH or wire payments to an external recipient',
  },
  viewStatements: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.exportStatements',
    description: 'Text explaining that a user can export statements.',
    defaultMessage: 'Download account statements',
  },
  viewTransactions: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.viewTransactions',
    description: 'Text explaining that a user can view transactions.',
    defaultMessage: 'View and export account transactions',
  },
  viewTheirTransactions: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.viewTheirTransactions',
    description: 'Text explaining that a user can view their transactions',
    defaultMessage: 'View their transactions',
  },
  freezeTheirCard: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.freezeTheirCard',
    description: 'Text explaining that a user can freeze their card.',
    defaultMessage: 'Freeze their card',
  },
  replaceTheirCard: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.replaceTheirCard',
    description: 'Text explaining that a user can replace their card.',
    defaultMessage: 'Replace their card',
  },
  editTerminalAndClimateSettings: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.editTerminalAndClimateSettings',
    description:
      'Text explaining that a user can edit terminal and climate settings.',
    defaultMessage: 'Edit terminal and climate settings',
  },
  addPaymentFingerprintToRadarAllowLists: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.addPaymentFingerprintToRadarAllowLists',
    description:
      'Text explaining that a user can add payment fingerprint to Radar allow lists',
    defaultMessage: 'Add payment fingerprint to radar allow lists',
  },
  configureTaxAndTaxFormSettings: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.configureTaxAndTaxFormSettings',
    description:
      'Text explaining that a user can configure Tax and tax form settings',
    defaultMessage: 'Configure tax and tax form settings',
  },
  configureTaxFormsForConnectedAccounts: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.configureTaxFormsForConnectedAccounts',
    description:
      'Text explaining that a user can configure tax forms for connected accounts.',
    defaultMessage: 'View, modify, and file tax forms for connected accounts',
  },
  fullAccessToTheTaxFormsView: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.fullAccessToTheTaxFormsView',
    description:
      'Text explaining that a user has full access to the tax forms view.',
    defaultMessage: 'Full access to the <a>tax forms</a> view',
  },
  viewInvoicesAndSubscriptions: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.viewInvoicesAndSubcriptions',
    description:
      'Text explaining that a user can view invoices and subcriptions',
    defaultMessage: 'View invoices and subscriptions',
  },
  issueCreditNotes: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.issueCreditNotes',
    description:
      'Text explaining that a user can issue credit notes on invoices',
    defaultMessage: 'Issue credit notes on invoices',
  },
  viewIssuingCards: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.viewIssuingCards',
    description: 'Text explaining that a user can view Issuing cards',
    defaultMessage: 'View Issuing cards',
  },
  createViewEditIssuingDisputes: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.createViewEditIssuingDisputes',
    description:
      'Text explaining that a user can create, view, and edit Issuing disputes',
    defaultMessage: 'Create, view, or edit Issuing disputes',
  },
  viewEditIssuingAuthorizations: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.viewEditIssuingAuthorizations',
    description:
      'Text explaining that a user can view and edit Issuing authorizations',
    defaultMessage: 'View and edit Issuing authorizations',
  },
  viewEditIssuingTransactions: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.viewEditIssuingTransactions',
    description:
      'Text explaining that a user can view and edit Issuing transactions',
    defaultMessage: 'View and edit Issuing transactions',
  },
  viewIssuingCardholders: {
    id: 'docsApp.components.contrib.thingsRolesCanDo.viewIssuingCardholders',
    description: 'Text explaining that a user can view Issuing cardholders',
    defaultMessage: 'View Issuing cardholders',
  },
  createEditDeleteIssuingCards: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.createEditDeleteIssuingCards',
    description:
      'Text explaining that a user can create, edit, and delete Issuing cards',
    defaultMessage: 'Create, edit, or delete Issuing cards',
  },
  createEditDeleteIssuingCardholders: {
    id:
      'docsApp.components.contrib.thingsRolesCanDo.createEditDeleteIssuingCardholders',
    description:
      'Text explaining that a user can create, edit, and delete Issuing cardholders',
    defaultMessage: 'Create, edit, or delete Issuing cardholders',
  },
});
